export const featureFlags = {
  SHOW_OFFER_DATES: false,
};
